import {
  ADDRESS_FIELD,
  SHOW_PRICE,
} from '@/components/PdfConfiguration/constants';

const initialState = {
  contactText: '',
  showAgentInfo: true,
  alwaysAskAgentInfo: false,
  addressField: ADDRESS_FIELD.DEFAULT,
  addressFieldDownload: ADDRESS_FIELD.DEFAULT,
  showPrice: SHOW_PRICE.SHOW,
  completeDevPhotos: true,
  exportInEnglish: false,
  // Location line of the user's branch for the address preview (read-only).
  previewLocation: null,
  isLoading: true,
  hasLoadError: false,
  // storeKey -> requestId of the latest update sent for that field.
  latestUpdateRequestIds: {},
  // storeKey -> last value confirmed by the backend (rollback target).
  persistedValues: {},
  // Updates are numbered as they are sent: the backend applies them in that
  // order, so a response older than the field's last confirmed update is
  // stale even if it arrives later.
  updateCount: 0,
  // updateCount when the last load was sent.
  updateCountOnLoad: 0,
  // requestId -> number of an update still in flight.
  pendingUpdateNumbers: {},
  // storeKey -> { number, requestId } of the newest confirmed update.
  confirmedUpdates: {},
  // storeKey -> true while the field shows the rollback of a failed latest
  // update, so an older save that succeeds later can still be shown.
  rolledBackFields: {},
};

export default initialState;
